import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '韩漫', to: '/category/kr' },
      { label: '日漫', to: '/category/jp' },
      { label: '国漫', to: '/category/cn' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '用户口碑', to: '/about#reputation' },
      { label: '联系我们', to: '/about#contact' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '阅读指南', to: '/about' },
      { label: '常见问题', to: '/about#faq' },
      { label: '版权声明', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-200/70" role="contentinfo">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-star-smile-fill text-2xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-900">星星动漫网</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              星星动漫网汇集韩漫、日漫、国漫等各类好看的漫画，免费全集在线观看。按地区分类，轻松找到你喜欢的作品，高清画质下拉式阅读体验。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 星星动漫网 XingXingDongMan.com —— 好看的漫画全集免费在线阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}